var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoffee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.58 22.75H6.21C3.47 22.75 1.25 20.52 1.25 17.79V10.47C1.25 7.73001 3.48 5.51001 6.21 5.51001H13.58C16.32 5.51001 18.54 7.74001 18.54 10.47V17.79C18.54 20.52 16.31 22.75 13.58 22.75ZM6.21 7.01001C4.3 7.01001 2.75 8.56001 2.75 10.47V17.79C2.75 19.7 4.3 21.25 6.21 21.25H13.58C15.49 21.25 17.04 19.7 17.04 17.79V10.47C17.04 8.56001 15.49 7.01001 13.58 7.01001H6.21Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 4.75C5.09 4.75 4.75 4.41 4.75 4V2.25C4.75 1.84 5.09 1.5 5.5 1.5C5.91 1.5 6.25 1.84 6.25 2.25V4C6.25 4.41 5.91 4.75 5.5 4.75Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4.75C9.09 4.75 8.75 4.41 8.75 4V2.25C8.75 1.84 9.09 1.5 9.5 1.5C9.91 1.5 10.25 1.84 10.25 2.25V4C10.25 4.41 9.91 4.75 9.5 4.75Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4.75C13.09 4.75 12.75 4.41 12.75 4V2.25C12.75 1.84 13.09 1.5 13.5 1.5C13.91 1.5 14.25 1.84 14.25 2.25V4C14.25 4.41 13.91 4.75 13.5 4.75Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7891 18.12C17.3791 18.12 17.0391 17.78 17.0391 17.37V8.94995C17.0391 8.53995 17.3791 8.19995 17.7891 8.19995C20.5291 8.19995 22.7491 10.43 22.7491 13.16C22.7491 15.89 20.5191 18.12 17.7891 18.12ZM18.5391 9.77995V16.54C20.0891 16.2 21.2491 14.81 21.2491 13.16C21.2491 11.51 20.0891 10.12 18.5391 9.77995Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.51 12.75H2C1.59 12.75 1.25 12.41 1.25 12C1.25 11.59 1.59 11.25 2 11.25H17.51C17.92 11.25 18.26 11.59 18.26 12C18.26 12.41 17.92 12.75 17.51 12.75Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.598b5d878f9477418a7794b081608e5e.svg";
export { ForwardRef as ReactComponent };